import '@styles/_global.scss';
import './index.css';
import 'core/error/utils/sentryInstrument';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Application } from 'core/application';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
        <Application />
    </React.StrictMode>,
);
